import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthorizedServicesMain } from '../models/models'

export class DeleteAuthorizedServicesMainApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesMain/delete/',
      requesterInfo,
    })
  }

  public async deleteAuthorizedServicesMain(id: number): Promise<IAuthorizedServicesMain[]> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<IAuthorizedServicesMain[]>()
  }
}
